import { useEffect, useRef, useState } from "react";
import { UserPlus, Save, X } from "lucide-react";
import api from "../services/api";
import Swal from "sweetalert2";

export default function ClientForm({
  fetchClients,
  editingClient,
  setEditingClient,
  onCancel,
}) {
  const nameRef = useRef(null);

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");

  useEffect(() => {
    if (editingClient) {
      setName(editingClient.nombre || "");
      setPhone(editingClient.telefono || "");
      setEmail(editingClient.email || "");
      setAddress(editingClient.direccion || "");
    } else {
      resetForm();
    }

    setTimeout(() => nameRef.current?.focus(), 100);
  }, [editingClient]);

  const resetForm = () => {
    setName("");
    setPhone("");
    setEmail("");
    setAddress("");
    setTimeout(() => nameRef.current?.focus(), 50);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      Swal.fire("Error", "Client name is required", "error");
      return;
    }

    const payload = { nombre: name };
    if (phone.trim()) payload.telefono = phone;
    if (email.trim()) payload.email = email;
    if (address.trim()) payload.direccion = address;

    try {
      if (editingClient) {
        await api.put(`/clients/${editingClient.id}`, payload);
        Swal.fire("Updated", "Client updated successfully", "success");
      } else {
        await api.post("/clients", payload);
        Swal.fire("Saved", "Client registered successfully", "success");
      }

      resetForm();
      setEditingClient(null);
      if (typeof fetchClients === "function") fetchClients();
      if (typeof onCancel === "function") onCancel();
    } catch (error) {
      if (error.response?.data?.errors) {
        const firstError = Object.values(error.response.data.errors)[0][0];
        Swal.fire("Error", firstError, "error");
      } else {
        Swal.fire("Error", "There was a problem saving the client", "error");
        console.error(error);
      }
    }
  };

  return (
    <div className="card" style={{ marginBottom: "24px" }}>
      <div className="card-header">
        <div className="d-flex align-items-center gap-2">
          <UserPlus size={24} color="#667eea" />
          <h2 className="card-title" style={{ fontSize: "20px" }}>
            {editingClient ? "Edit Client" : "New Client"}
          </h2>
        </div>
      </div>

      <div className="card-body">
        <form onSubmit={handleSubmit}>
          <div className="form-group" style={{ marginBottom: "20px" }}>
            <label className="form-label">Full Name *</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter client name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              ref={nameRef}
              required
            />
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
              gap: "16px",
              marginBottom: "20px",
            }}
          >
            <div className="form-group">
              <label className="form-label">Phone</label>
              <input
                className="form-control"
                placeholder="(000) 000-0000"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label className="form-label">Email</label>
              <input
                type="email"
                className="form-control"
                placeholder="email@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>

          <div className="form-group" style={{ marginBottom: "24px" }}>
            <label className="form-label">Address</label>
            <input
              className="form-control"
              placeholder="Full address"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
          </div>

          <div className="d-flex gap-2" style={{ marginTop: "8px" }}>
            <button type="submit" className="btn btn-success">
              <Save size={18} />
              {editingClient ? "Update Client" : "Save Client"}
            </button>

            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => {
                resetForm();
                setEditingClient(null);
                if (typeof onCancel === "function") onCancel();
              }}
            >
              <X size={18} />
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}